module.exports = __webpack_public_path__ + "img/level.d5243c51.svg";